<template lang="pug">
  .container-grid
    h2 painel de acompanhamento
    .content-grid-panel(ref="container")

      .wrapper-extra-time-dash-header
        .dates
          PDatePicker(
            name="date"
            label="data"
            v-model="date"
            :range="true"
            format="DD/MM/YY"
          )

        .companies
          PMultiSelect(
            title="locais de trabalho"
            labelItem="name"
            useState="dashboards/companies"
            useCommon="companies/onlyActive"
          )

        .types-selector
          PSelect(
            labelItem="name",
            title="tipo",
            v-model="typeViewOptions"
          )

        .filters
          PMultiSelect(
            labelItem="name"
            :title="typeSelected.name"
            v-model="filterOptions"
          )

        .buttons
          PButton(color="success" size="md", @click="loadCharts", block) ok
          PButton(color="info" size="md", @click="toggleRowOptions", block)
            .icon-ptt-icons-config

        transition(name="bounce")
          .header-row-options(v-show="showRowOptions")

            span configurações de exibição:
            .option
              span ordernar por:
              PRadio(label="somas", useState="dashboards/orderBy", option="daysHours", @change="loadCharts")
              PRadio(label="nome", useState="dashboards/orderBy", option="name", @change="loadCharts")
            .option
              span tipo de soma:
              PRadio(label="total", useState="dashboards/sumType", option="total", @change="loadCharts")
              PRadio(label="média", useState="dashboards/sumType", option="proportion", @change="loadCharts")
            .option
              span considerar {{ $wp('companyShortName') }} do:
              PRadio(label="empregado", useState="dashboards/groupPerLineCompany", option="false", @change="loadCharts")
              PRadio(label="pontos batidos", useState="dashboards/groupPerLineCompany", option="true", @change="loadCharts")

      .dashboard-container(ref="containerView")
        img(v-if="compManLogo", :src="compManLogo")

        BarsView(
          v-if="chartType === 'bars'",
          :periodInfoLegend="dateTitle",
          :labelCompany="labelType.company",
          :labelEmployee="labelType.employee",
          :colors="colors",
          ref="barsView"
          @changeChartType="changeChartType"
          @toggleFullScreen="toggleFullScreen"
        )

        PieView(
          v-if="chartType === 'pie'",
          :labelCompany="labelType.company",
          :labelEmployee="labelType.employee",
          :colors="colors",
          ref="pieView"
          @changeChartType="changeChartType"
          @toggleFullScreen="toggleFullScreen"
        )
</template>

<script>
import { CompStoreModule } from 'src/common/mixins/abstractComponents'
import { openElementInFullscreen, closeFullscreen } from 'src/utils'
import BarsView from 'src/components/DashBoards/bars/BarsView'
import PieView from 'src/components/DashBoards/pie/PieView'
import RadioSlider from 'src/common/Tabs/RadioSlider'
import { mapState } from 'vuex'
import moment from 'moment'
import _ from 'lodash'
import { setAmplitudeEvent } from 'src/amplitudeUtils'

export default {
  extends: CompStoreModule,
  storeModule: 'dashboards',
  created () {
    this.$store.commit('dashboards/resetState')
    this.$store.commit('dashboards/types', {selected: this.filters.types})
    this.$store.commit('dashboards/typesSpecial', {selected: this.filters.typesSpecial})
    this.$store.commit('dashboards/typesWhb', {selected: this.filters.typesWhb})
    this.typeView = this.$store.state.dashboards.typeView
  },
  async mounted () {
    this.date = {
      start: moment().subtract(30, 'days').toDate(),
      end: moment().toDate()
    }

    const res = await this.$API.company.get({
      id: this.$store.state.userInfo.firstCompany,
      fields: JSON.stringify([
        'id', 'name', 'active', 'has_on_call', 'code'
      ])
    })
    const company = res.body.success[0]
    this.$store.commit('dashboards/companies', {selected: [company]})
    this.loadCharts()
    setAmplitudeEvent('lista painel de acompanhamento', {})
  },
  data () {
    return {
      fullscreen: false,
      baseWidth: 0,
      showRowOptions: false,
      filters: {
        types: [
          {id: 'extraTime50Tot', name: 'Hora Extra'},
          {id: 'extraTime100Tot', name: 'Hora Extra Extraordinárias'},
          {id: 'extraTimeSpecialTot', name: 'Hora Extra Especiais'},
          {id: 'extraTime50NotTot', name: 'Hora Extra Noturnas'},
          {id: 'extraTime100NotTot', name: 'H.E. Extraord Not'},
          {id: 'extraTimeSpecialNotTot', name: 'Hora Extra Especiais Noturnas'},
          {id: 'delayTime', name: 'Atraso'}
        ],
        typesSpecial: [
          {id: 'absence', name: 'Faltas'},
          {id: 'folgaTrabalhada', name: 'Folgas Trabalhadas'},
          {id: 'holidayWorked', name: 'Feriado Trabalhado'},
          {id: 'justify', name: 'Dispensas'},
          {id: 'suspension', name: 'Suspensões'},
          {id: 'oddPts', name: 'Batida ímpar'},
          {id: 'leave', name: 'Afastamento'},
          {id: 'vacation', name: 'Férias'}
        ],
        typesWhb: [
          {id: 'allTimes', name: 'Consolidado'},
          {id: 'generalExtraTime', name: 'Horas positivas'},
          {id: 'generalDelay', name: 'Horas negativas'}
        ]
      },
      labelType: {
        company: 'name',
        employee: 'name'
      },
      baseheight: (screen.height - 100) / 3, // calculated height of each graph based in user monitor
      colors: {
        'extraTime50Tot': '#99c9d3',
        'extraTime100Tot': '#00a2b5',
        'extraTimeSpecialTot': '#fed497',
        'extraTime50NotTot': '#f4af9d',
        'extraTime100NotTot': '#aa7a6d',
        'extraTimeSpecialNotTot': '#ffca54',
        'delayTime': '#ff6854',
        'absence': '#ff6854',
        'justify': '#ffca54',
        'folgaTrabalhada': '#99c9d3',
        'holidayWorked': '#aa7a6d',
        'suspension': '#f4af9d',
        'allTimes': '#00a2b5',
        'generalDelay': '#b53800',
        'generalExtraTime': '#a2b500',
        'oddPts': '#d27e15',
        'leave': '#fed497',
        'vacation': '#a2b500'
      },
      typeView: null
    }
  },
  computed: {
    ...mapState('dashboards', ['chartType']),
    compManLogo () {
      return this.$store.state.userInfo.compMan.logoUrl
    },
    dateTitle () {
      const { startDate, endDate, typeView } = this.$store.state.dashboards
      const typeViewName = {
        extraTime: 'apontamentos',
        special: 'eventos',
        whb: 'banco de horas'
      }
      return {
        type: `${typeViewName[typeView]}`,
        interval: `(de ${moment(startDate).format('DD.MM.YYYY')} - ${moment(endDate).format('DD.MM.YYYY')})`
      }
    },
    typeViewOptions: {
      get () {
        const options = [
          {id: 'extraTime', name: 'apontamentos', useState: 'dashboards/types', filterName: 'types'},
          {id: 'special', name: 'eventos', useState: 'dashboards/typesSpecial', filterName: 'typesSpecial'},
          {id: 'whb', name: 'banco de horas', useState: 'dashboards/typesWhb', filterName: 'typesWhb'}
        ]
        return {
          selected: _.find(options, option => option.id === this.typeView),
          loaded: options
        }
      },
      set (option) {
        if (!option.selected) return
        this.typeView = option.selected.id
      }
    },
    typeSelected () {
      return this.typeViewOptions.selected
    },
    filterOptions: {
      get () {
        const store = this.$store.state.dashboards
        const filterName = this.typeSelected.filterName
        return {
          loaded: this.filters[filterName],
          selected: store[filterName].selected
        }
      },
      set (value) {
        this.$store.commit(
          this.typeSelected.useState,
          {selected: value.selected}
        )
      }
    },
    date: {
      get () {
        return {
          start: this.$store.state.dashboards.startDate,
          end: this.$store.state.dashboards.endDate
        }
      },
      set (value) {
        this.$store.commit(
          'dashboards/startDate',
          value.start
        )
        this.$store.commit(
          'dashboards/endDate',
          value.end
        )
      }
    }
  },
  methods: {
    loadCharts () {
      this.$store.commit('dashboards/resetState')
      this.$store.commit('dashboards/typeView', this.typeView)
      if (this.chartType === 'bars') {
        this.$refs.barsView.loadCompaniesGraph()
      } else {
        this.$refs.pieView.loadTotalGraph()
      }
    },
    changeChartType (item) {
      this.$store.commit(
        'dashboards/chartType',
        item.id
      )
      this.$nextTick(() => {
        this.loadCharts()
      })
    },
    toggleFullScreen () {
      this.fullscreen = !this.fullscreen
      if (this.fullscreen) {
        openElementInFullscreen(this.$refs.containerView, () => {
          this.fullscreen = false
        })
      } else {
        closeFullscreen()
      }
    },
    toggleRowOptions () {
      this.showRowOptions = !this.showRowOptions
    }
  },
  components: { BarsView, PieView, RadioSlider }
}
</script>

<style scoped lang="scss">
.container-grid {
  display: block;
}
h2 {
  text-align: center;
}
.content-grid-panel {
  box-sizing: border-box;
}

.wrapper-extra-time-dash-header {
  display: grid;
  grid-template-columns: .5fr 1fr .5fr 1fr .3fr;
  grid-column-gap: 10px;
  grid-template-rows: auto auto;
  align-items: center;
  grid-row-gap: 5px;

  .types-selector {
    display: grid;
  }

  .buttons {
    display: grid;
    grid-template-columns: 1fr .5fr;
    grid-gap: 1px;
  }

  .header-row-options {
    display: grid;
    grid-column-start: 1;
    grid-column-end: 6;
    grid-template-columns: auto auto auto auto;
    align-items: center;

    & > * {
      font-size: 13px;
    }

    .option {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      align-items: center;

      .p-radio {
        margin-bottom: 0;
      }
    }
  }
}

.dashboard-container {
  .chart-type-selector {
    width: 200px;
  }
}

.dashboard-container:fullscreen {
  z-index: 9999;
  width: 100%;
  height: 95%;
  position: fixed;
  padding: 40px 50px 40px 50px !important;
  top: 0;
  left: 0;
  background-color: white;
}
.dashboard-container:fullscreen .companies-legends, .dashboard-container:fullscreen .employees-legends {
  grid-template-columns: repeat(4, 1fr) !important;
  grid-template-rows: repeat(3, 1fr) !important;
  grid-auto-flow: row !important;
}

.dashboard-container img {
  display: none;
}
.dashboard-container:fullscreen img {
  display: inline;
  position: fixed;
  max-width: 10% !important;
  right: 3%;
  top: 2%;
}

.full-screen-togler {
  position: absolute;
  right: 20px;
  top: 50px;
}
</style>
